// src/Dashboard/pages/user/Boutique/components/BoutiqueArticleCard.jsx

import React from "react";
import { FaCartPlus, FaEye } from "react-icons/fa";

import {
  FALLBACK_ARTICLE_IMAGE,
  formatEUR,
  getArticleImage,
  getStockBadgeClass,
  getStockLabel,
  isOutOfStock,
} from "../utils/boutiqueUtils";

export default function BoutiqueArticleCard({ article, onOpen, onAdd }) {
  const image = getArticleImage(article);
  const out = isOutOfStock(article);

  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-[24px] border border-slate-200 bg-white shadow-sm transition hover:-translate-y-0.5 hover:shadow-md dark:border-slate-800 dark:bg-slate-950">
      <button
        type="button"
        onClick={onOpen}
        className="relative block w-full overflow-hidden bg-slate-100 text-left dark:bg-slate-900"
      >
        <div className="w-full" style={{ aspectRatio: "4 / 3" }}>
          <img
            src={image}
            alt={article.nom || "Article"}
            className="h-full w-full object-cover transition duration-500 group-hover:scale-[1.04]"
            loading="lazy"
            onError={(event) => {
              event.currentTarget.src = FALLBACK_ARTICLE_IMAGE;
            }}
          />
        </div>

        <div className="absolute left-3 top-3 flex flex-wrap gap-2">
          {article.categorie && (
            <span className="rounded-full bg-slate-950/80 px-3 py-1 text-xs font-bold text-white shadow-sm">
              {article.categorie}
            </span>
          )}

          <span
            className={`rounded-full px-3 py-1 text-xs font-bold shadow-sm ring-1 ${getStockBadgeClass(
              article
            )}`}
          >
            {getStockLabel(article)}
          </span>
        </div>
      </button>

      <div className="flex flex-1 flex-col p-4">
        <div className="flex items-start justify-between gap-3">
          <h3 className="line-clamp-2 text-base font-bold leading-tight text-slate-900 dark:text-white">
            {article.nom || "Sans nom"}
          </h3>

          <p className="shrink-0 text-xl font-bold text-slate-900 dark:text-white">
            {formatEUR(article.prix)}
          </p>
        </div>

        <p className="mt-3 line-clamp-3 min-h-[66px] text-sm leading-6 text-slate-600 dark:text-slate-300">
          {article.description || "Aucune description disponible."}
        </p>

        <div className="mt-3 flex flex-wrap gap-2 text-xs">
          {article.taille && (
            <span className="rounded-full bg-slate-100 px-3 py-1 font-bold text-slate-700 ring-1 ring-slate-200 dark:bg-slate-900 dark:text-slate-200 dark:ring-slate-700">
              Taille : {article.taille}
            </span>
          )}

          {article.is_stockable && (
            <span
              className={`rounded-full px-3 py-1 font-bold ring-1 ${getStockBadgeClass(
                article
              )}`}
            >
              {out ? "Indisponible" : `${article.quantite_stock} en stock`}
            </span>
          )}
        </div>

        <div className="mt-auto grid grid-cols-2 gap-2 border-t border-slate-200 pt-4 dark:border-slate-800">
          <button
            type="button"
            onClick={onOpen}
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-slate-100 px-3 py-2 text-sm font-bold text-slate-700 ring-1 ring-slate-200 transition hover:bg-slate-200 dark:bg-slate-900 dark:text-slate-200 dark:ring-slate-700 dark:hover:bg-slate-800"
          >
            <FaEye />
            Voir
          </button>

          <button
            type="button"
            onClick={onAdd}
            disabled={out}
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-[#013E8E] px-3 py-2 text-sm font-bold text-white transition hover:bg-indigo-800 disabled:cursor-not-allowed disabled:opacity-50"
          >
            <FaCartPlus />
            {out ? "Épuisé" : "Ajouter"}
          </button>
        </div>
      </div>
    </article>
  );
}